module.exports = __webpack_public_path__ + "media/images/emblems/Arogno-coat_of_arms-16cf0088e114b4bf70f6f5321d307caa.svg";